import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Grid, Skeleton } from '@mui/material';
import TitleBar from '@/components/_common/TitleBar';
import Breadcrumbs from '@/components/_common/Breadcrumbs';
import { selectTitle, selectTitleLoading, selectTitleSeasonsObject } from '@/redux/selectors/titleSelectors';
import { useQuery } from '@/components/_hooks/useQuery';
import Refresh from '@/components/_common/Refresh';
import { getTitleDetails, getTitleVersions } from '@/redux/slices/titleSlice';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

interface Breadcrumb {
  label: string;
  url?: string;
}

const TitleTitleBar = () => {
  const { id } = useParams<{ id: string }>();

  const dispatch = useAppDispatch();
  const seasons = useAppSelector(selectTitleSeasonsObject);
  const title = useAppSelector(selectTitle);
  const loadingTitle = useAppSelector(selectTitleLoading);

  // grab the season and episode IDs for lookups
  const query = useQuery();
  const tab = query.get('tab') || 'metadata';
  const seasonId = query.get('season_id');
  const episodeId = query.get('episode_id');

  const breadcrumbs: Breadcrumb[] = [];

  // when there is an id param, add title name to breadcrumbs
  if (id) breadcrumbs.push({ label: title?.name ?? '', url: id + `?tab=${tab}` });

  // when there is a season id, find and add season to breadcrumbs
  if (seasonId) {
    const season = seasons[seasonId] || {};
    breadcrumbs.push({ label: season.name, url: `${id}?tab=${tab}&season_id=${seasonId}` });
  }

  // when there is a episode id, find and add episode to breadcrumbs
  if (seasonId && episodeId) {
    const episode = seasons[seasonId]?.children?.find((ep) => {
      return ep.id === parseInt(episodeId);
    });

    if (episode) {
      breadcrumbs.push({ label: episode.name });
    }
  }

  // remove whatever the last breadcrumb ended up being
  // because it should not be a link
  const lastBreadcrumb = breadcrumbs.pop();

  return (
    <TitleBar style={{ marginBottom: 50 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/titles" key="titles">
            Titles
          </Link>
          {breadcrumbs.map((breadcrumb, i) => (
            <Link key={breadcrumb.label + i} to={`/titles/${breadcrumb.url}`}>
              {loadingTitle ? <Skeleton variant="text" width={100} /> : breadcrumb.label}
            </Link>
          ))}
          <span>{loadingTitle ? <Skeleton variant="text" width={100} key="episode" /> : lastBreadcrumb && <span>{lastBreadcrumb.label}</span>}</span>
        </Breadcrumbs>
        <Refresh
          onClick={() => {
            dispatch(getTitleDetails(+id));
            dispatch(getTitleVersions(+id));
          }}
        />
      </Grid>
    </TitleBar>
  );
};

export default TitleTitleBar;
